import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { Actions, Action, ReplayIcon } from '@gogame/components';

import { useGroup } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';
import { useLoader } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Loader';
import { usePlanResetBudget } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanState';
import {
  useViewStateByResolveName,
  useViewStateByPath,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { useCreateNodesMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/hooks';

export default ({ withAllocatedBudgetLeft }) => {
  const { processAsync } = useLoader();
  const { levelPath, activityType } = useGroup();
  const onResetBudget = usePlanResetBudget();
  const createNodes = useCreateNodesMarketingPlan(processAsync);

  const handleResetBudget = React.useCallback(() => {
    onResetBudget({ levelPath, activityType });
  }, [levelPath, activityType]);

  const { id, depth, nodes } = useViewStateByPath(levelPath);
  const { budgetLeft } = useViewStateByResolveName();

  const handleAllocatedBudgetLeft = React.useCallback(() => {
    createNodes({
      parentId: id,
      depth: depth + 1,
      entityIds: [null],
      levelPath,
      node: {
        activityTypes: {
          [activityType]: {
            budget: budgetLeft,
          },
        },
      },
      typeRequest: 'allocatedBudgetLeft',
    });
  }, [id, depth, levelPath, activityType, budgetLeft]);

  const disabledAllocatedBudgetLeft = React.useMemo(
    () => nodes.some(({ entityId }) => entityId === -1),
    [nodes]
  );

  const disabledResetBudget = React.useMemo(() => isEmpty(nodes), [nodes]);

  return (
    <Actions limit={withAllocatedBudgetLeft ? 0 : 1}>
      {withAllocatedBudgetLeft ? (
        <Action
          label={'Allocate budget left'}
          onClick={handleAllocatedBudgetLeft}
          disabled={disabledAllocatedBudgetLeft}
        />
      ) : null}
      <Action
        label={'Reset budget'}
        onClick={handleResetBudget}
        icon={<ReplayIcon />}
        disabled={disabledResetBudget}
      />
    </Actions>
  );
};
